import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>404 - Page Not Found</h1>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <p>Try one of these links to get back on track:</p>
      <Link to="/" style={{ margin: "10px", textDecoration: "none", color: "#007bff" }}>Go to Homepage</Link>
      <Link to="/contact" style={{ margin: "10px", textDecoration: "none", color: "#007bff" }}>Contact Us</Link>
      <Link to="/blog" style={{ margin: "10px", textDecoration: "none", color: "#007bff" }}>Visit Our Blog</Link>
    </div>
  );
};

export default NotFound;
